import 'regenerator-runtime/runtime';
import './scss/index';
import VueLoader from './js/loaders/VueLoader';
import LayoutLoader from './js/loaders/LayoutLoader';

const $ = jQuery;

const components = {
    'hello' : import('./js/components/Hello')
}

const layouts = {
    'fusion-blog-article' : import('./js/layouts/FusionBlogArticle')
};

new VueLoader(components);
new LayoutLoader(layouts);

function queryLayouts(){
    $('.fusion-blog-shortcode article:not([data-js-layout-rendered])')
        .attr('data-js-layout', 'fusion-blog-article');
}

if (window.MutationObserver) {
    const observer = new MutationObserver(() => queryLayouts());
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}
$(queryLayouts);